/**
 * Created by fgaule on 11/11/16.
 */
angular.module('CarsSaraBo').factory('$page', ['$translate', function ($translate) {
    var sectionTitle;

    return {
        setTitle: function (sectionTitleKey) {
            $translate('common.TITLE').then(function (title) {
                var applicationTitle = title;
                if (sectionTitleKey) {
                    sectionTitle = $translate.instant(sectionTitleKey);

                    if (sectionTitle) {
                        applicationTitle = applicationTitle + " - " + sectionTitle;
                    }
                }
                // we have to call document.title cause our applications is binding to <body> instead of <html> where we would have access to <header><title> :(
                document.title = applicationTitle;
            });
        }
    };
}]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/page_service.js
// module id = 857
// module chunks = 3